import b from 'b_';
import cx from 'classnames';
import React from 'react';

import { UI_KIT_TEXT_TYPOGRAPHY } from '../constants';
import Text from '../text/text';

import './symbols-counter.scss';

interface Props {
    className?: string;
    current: number;
    limit: number;
}

export const SymbolsCounter = (props: Props) => {
    const { className, current, limit } = props;

    return (
        <Text
            className={cx(b('symbols-counter', { overflowed: current >= limit }), className)}
            typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
        >
            <span className="symbols-counter__count">{current}</span>/{limit}
        </Text>
    );
};
